import { render, staticRenderFns } from "./ConfigutionCard.vue?vue&type=template&id=43376db3&scoped=true"
import script from "./ConfigutionCard.vue?vue&type=script&lang=js"
export * from "./ConfigutionCard.vue?vue&type=script&lang=js"
import style0 from "./ConfigutionCard.vue?vue&type=style&index=0&id=43376db3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43376db3",
  null
  
)

export default component.exports